import { render } from "./Team_partner_m.vue?vue&type=template&id=88c8c552&scoped=true"
import script from "./Team_partner_m.vue?vue&type=script&lang=js"
export * from "./Team_partner_m.vue?vue&type=script&lang=js"

import "./Team_partner_m.vue?vue&type=style&index=0&id=88c8c552&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-88c8c552"

export default script